export default "__VITE_ASSET__DnVZUV9D__"